import { Controller } from "@hotwired/stimulus"

// External link confirmation — intercepta cliques em links marcados que apontam
// pra FORA do domínio da aplicação e pede confirmação antes de sair, abrindo o
// destino em nova aba. Links internos seguem direto, sem interceptação.
//
// Controller vive no MODAL (renderizado uma vez no layout). A interceptação é
// por delegação no document (mesmo padrão do dialog): qualquer
// `<a data-external-link href="...">` na página é coberto, sem acoplar o link
// ao modal.
//
//   <a href="https://site.com" data-external-link>...</a>
//   <%= render "shared/external_link_dialog" %>  (uma vez no layout)
//
// A11y/segurança: abre com noopener,noreferrer. Esc/backdrop/cancelar fecham
// (delegado ao dialog_controller, que controla o mesmo elemento).
export default class extends Controller {
  static targets = ["host", "confirm"]
  static values  = { dialogId: { type: String, default: "external-link-dialog" } }

  connect() {
    this.pendingUrl = null
    this.boundClick = this.maybeIntercept.bind(this)
    document.addEventListener("click", this.boundClick)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClick)
  }

  maybeIntercept(event) {
    const link = event.target.closest("a[data-external-link]")
    if (!link) return

    const href = link.getAttribute("href")
    if (!href || !this.isExternal(href)) return // interno/inválido → navega normal

    event.preventDefault()
    this.pendingUrl = href
    if (this.hasHostTarget) this.hostTarget.textContent = this.hostOf(href)
    this.openDialog()
  }

  // Confirma → abre o destino em nova aba e fecha o modal.
  proceed() {
    if (this.pendingUrl) {
      window.open(this.pendingUrl, "_blank", "noopener,noreferrer")
      this.pendingUrl = null
    }
    this.closeDialog()
  }

  // ── helpers ──────────────────────────────────────────────────────────────
  isExternal(href) {
    try {
      return new URL(href, window.location.origin).host !== window.location.host
    } catch {
      return false // href relativo malformado → trata como interno (navega normal)
    }
  }

  hostOf(href) {
    try {
      return new URL(href, window.location.origin).host
    } catch {
      return href
    }
  }

  // Abre/fecha o dialog reaproveitando o dialog_controller que controla o mesmo
  // elemento (via data-dialog-trigger / método close).
  openDialog() {
    const dialog = document.getElementById(this.dialogIdValue)
    const ctrl = this.dialogController(dialog)
    ctrl ? ctrl.open() : dialog?.classList.remove("hidden")
  }

  closeDialog() {
    const dialog = document.getElementById(this.dialogIdValue)
    const ctrl = this.dialogController(dialog)
    if (ctrl) ctrl.close()
  }

  dialogController(el) {
    if (!el || !window.Stimulus) return null
    return window.Stimulus.getControllerForElementAndIdentifier(el, "dialog")
  }
}
